import { type FC, memo } from "react";
import dayjs from "dayjs";
import { ButtonKind, ButtonShape, ButtonSize, ButtonVariant, Heading, IconButton } from "@stubhub/broadway-web";
import { ChevronLeftIcon, ChevronRightIcon } from "@stubhub/broadway-web/icons/functional";
import { useContent } from "src/shared/components/content/hooks";
import { useLocaleDayjs } from "src/website-apps/shared/hooks/useLocaleDayjs";
import { navRowStyle, titleContainerStyle } from "./ResidencyMonthNavigation.styles";

interface Props {
  availableMonths: Date[];
  currentMonth: Date;
  onPrev: () => void;
  onNext: () => void;
}

export const ResidencyMonthNavigation: FC<Props> = memo(({ availableMonths, currentMonth, onNext, onPrev }) => {
  const localeDayjs = useLocaleDayjs();
  const nextMonthContent = useContent("cid$#3562207#"); // "Next Month"
  const prevMonthContent = useContent("cid$#3562206#"); // "Previous Month"
  const currentIndex = availableMonths.findIndex((m) => dayjs(m).isSame(currentMonth, "month"));
  const isFirst = currentIndex <= 0;
  const isLast = currentIndex >= availableMonths.length - 1;
  const formattedLabel = localeDayjs(currentMonth).format("MMMM YYYY");

  return (
    <div className={navRowStyle}>
      <IconButton
        aria-label={prevMonthContent}
        disabled={isFirst}
        icon={ChevronLeftIcon}
        kind={ButtonKind.Neutral}
        onClick={onPrev}
        shape={ButtonShape.Round}
        size={ButtonSize.Default}
        variant={ButtonVariant.Outline}
      />
      <div className={titleContainerStyle}>
        <Heading variant="header" size="medium" as="h2">
          {formattedLabel}
        </Heading>
      </div>
      <IconButton
        aria-label={nextMonthContent}
        disabled={isLast}
        icon={ChevronRightIcon}
        kind={ButtonKind.Neutral}
        onClick={onNext}
        shape={ButtonShape.Round}
        size={ButtonSize.Default}
        variant={ButtonVariant.Outline}
      />
    </div>
  );
});

ResidencyMonthNavigation.displayName = "ResidencyMonthNavigation";
